import styled from 'styled-components';

import SwitchableSubscription, { TSwitchableSubscriptionProps } from './SwitchableSubscription';

export const StyledTariffSubscription = styled(SwitchableSubscription)<TSwitchableSubscriptionProps>`
    width: 100%;
    display: flex;

    flex-direction: row;
    flex-wrap: nowrap;

    justify-content: space-between;
    align-items: flex-start;

    & > *:last-child {
        align-self: ${({ switcherAlign = 'center' }) => switcherAlign};
        margin-top: ${({ switcherAlign = 'center', iconSize = 16 }) => {
            if (switcherAlign === 'start' && iconSize === 16) {
                return '2px';
            }

            if (switcherAlign === 'start' && iconSize === 20) {
                return '4px;';
            }

            return '0';
        }};
    }
`;

StyledTariffSubscription.displayName = 'SwitchableSubscription';

export default StyledTariffSubscription;
